import * as React from 'react';
import { translate } from 'react-i18next';
import ConfirmationDialog from 'common/components/ui/ConfirmationDialog';
import Proposition from 'common/modules/proposition/domain/proposition';
import { ActionType } from '../decorators/withPropositionActions';

export const DIALOG_ID = 'action-on-proposition-confirmation-dialog';

interface Props {
  action: string;
  onCancel: () => void;
  onConfirm: () => void;
  open: boolean;

  proposition: Proposition;
  type: ActionType;
  t: (key: string) => string;
}

export function ActionOnPropositionConfirmationDialog({ proposition, t, type, ...rest }: Props) {
  const otherProps = {};
  if (type === 'SEND' && !proposition.customer.hasAccessToFollo) {
    otherProps.message = t('customerWillBeAbleToAccessPropositionOnFollo', { name: proposition.customer.name });
  }

  return (
    <ConfirmationDialog
      id={DIALOG_ID}
      {...rest}
      {...otherProps}
    />
  );
}

export default translate('proposition')(ActionOnPropositionConfirmationDialog);



// WEBPACK FOOTER //
// ./src/statsradio/modules/proposition/components/ActionOnPropositionConfirmationDialog.js